import { Component, ViewChild, ViewEncapsulation } from '@angular/core';
import { FloatingMenuOption } from 'src/app/common/components/master-floating-menu/model/master-floating-model';
import { EmployeeService } from './employee.service';
import { EmployeeTypeService } from '../system/employee-type/employee-type.service';
import { EmployeeJobBreakDialogComponent } from './employee-job-break-dialog/employee-job-break-dialog.component';
import { JobPositionService } from '../system/job-position/job-position.service';
import { EmployeeCategoryModel } from './model/employee-category.model';
import { MatDialog } from '@angular/material/dialog';
import { SnackBarService } from 'src/app/common/components/snackbar/snackbar.service';
import { SnackBarData } from 'src/app/common/components/snackbar/model/snackbar.model';
import { ColumnFilter, RequestData, SearchSort } from 'src/app/common/models/request-data.model';
import { BreakpointObserver, BreakpointState, Breakpoints } from '@angular/cdk/layout';
import { ConfirmDialogComponent, ConfirmDialogModel } from 'src/app/common/components/confirm-dialog/confirm-dialog.component';
import { SelectionModel } from '@angular/cdk/collections';
import { FilterListItemModel, SearchFilterComponent, SearchParam } from 'src/app/common/components/search-filter/search-filter.component';
import { Router } from '@angular/router';
import { StateManagerService } from 'src/app/common/services/state.manager.service';
import { MatTableDataSource } from '@angular/material/table';
import { MatSort, SortDirection } from '@angular/material/sort';
import { PermissionService } from 'src/app/auth/permission.service';


@Component({
  selector: 'app-employee',
  templateUrl: './employee.component.html',
  styleUrl: './employee.component.scss',
  standalone: false
})
export class EmployeeComponent {
  employeeList: EmployeeCategoryModel[] = [];

  showSearch: boolean = false;
  isLoading = true;
  IsDownloading = false;
  isInitializing = true;

  filter: FilterListItemModel[] = [];
  employeeTypesList: any[] = [];
  employeeStatusesList: any[] = [];
  jobPositionsList: any[] = [];
  displayedColumns = ['id', 'f_name', 'shop', 'payroll_code', 'gender', 'employee_type', 'job_position', 'phone', 'employee_status', 'action'];
  pagingData = { length: 0, pageSize: 50, pageIndex: 0 };
  menuOption: FloatingMenuOption = {
    add: true,
    search: false,
    export: true,
    more: true
  }

  isHandset: boolean = false;
  searchColumFilter: SearchParam = {};
  columnSortData: SearchSort[] = [];
  selectedItem?: EmployeeCategoryModel;
  showSummaryPanel: boolean = false;
  selection = new SelectionModel<EmployeeCategoryModel>(true, []);
  dataSource = new MatTableDataSource(this.employeeList);
  permission: any;
  userData: any;

  constructor(private breakpointObserver: BreakpointObserver,
    private employeeService: EmployeeService,
    private employeeTypeService: EmployeeTypeService,
    private jobPositionService: JobPositionService,
    private stateManagerService: StateManagerService,
    public dialog: MatDialog,
    public permissionService: PermissionService,
    private snackBarService: SnackBarService,
    private router: Router) {

    this.employeeList = [];
    this.permission = this.permissionService.getPagePermission('employee');
    const userDetailsData = sessionStorage.getItem('user');
    if (userDetailsData) {
      this.userData = JSON.parse(userDetailsData);
      console.log(this.userData.user_shops);
    }
    this.initializeFilters();
    this.loadEmployeeTypes();
    this.loadEmployeeStatuses();
    this.loadJobPositions();
  }

  initializeFilters(): void {
    const filters: FilterListItemModel[] = [
      { title: "Id", column: "e.id" },
      { title: "Name", column: "e.f_name" },
      {
        title: "Gender", column: "e.gender", type: "list",
        values: [
          { title: "Male", value: "male" },
          { title: "Female", value: "female" },
        ]
      }
    ];

    if (this.userData && this.userData.user_shops && this.userData.user_shops.length > 0) {
      filters.push({
        title: "Shop",
        column: "s.name",
        type: "list",
        values: this.userData.user_shops.map((shop: any) => ({
          title: shop.name,
          value: shop.name
        }))
      });
    }

    filters.push(
      {
        title: "Employee Type",
        column: "et.name",
        type: "list",
        includeFreeSearch: true,
        values: this.employeeTypesList
      },
      {
        title: "Job Position",
        column: "ejp.name",
        type: "list",
        includeFreeSearch: true,
        values: this.jobPositionsList
      },
      { title: "Phone", column: "e.phone" },
      {
        title: "Status",
        column: "es.name",
        type: "list",
        includeFreeSearch: true,
        values: this.employeeStatusesList
      }
    );

    this.filter = filters;
  }

  loadEmployeeTypes(): void {
    const requestData: RequestData = {
      search: {
        filters: {
          simpleSearch: [],
          advSearch: [],
          scope: {
            limit: 100,
            offset: 0
          }
        },
        sort: [{ column: 'name', order: 'asc' }]
      }
    };
    this.employeeTypeService.getEmployeeTypeList(requestData).subscribe({
      next: (response) => {
        if (response && response.status === 'SUCCESS') {
          const types = response.data.employee_types || [];
          this.employeeTypesList = types.map((t: any) => ({
            title: t.name,
            value: t.name
          }));
          this.initializeFilters();
        }
      },
      error: (err) => {
        console.error('Failed to load employee types', err);
      }
    });
  }

  loadEmployeeStatuses(): void {
    const requestData: RequestData = {
      search: {
        filters: {
          simpleSearch: [],
          advSearch: [],
          scope: {
            limit: 100,
            offset: 0
          }
        },
        sort: [{ column: 'name', order: 'asc' }]
      }
    };
    this.employeeService.getEmployeeStatusesList(requestData).subscribe({
      next: (response) => {
        if (response && response.status === 'SUCCESS') {
          const statuses = response.data.statuses || [];
          this.employeeStatusesList = statuses.map((s: any) => ({
            title: s.name,
            value: s.name
          }));
          this.initializeFilters();
        }
      },
      error: (err) => {
        console.error('Failed to load employee statuses', err);
      }
    });
  }

  loadJobPositions(): void {
    const requestData: RequestData = {
      search: {
        filters: {
          simpleSearch: [],
          advSearch: [],
          scope: {
            limit: 100,
            offset: 0
          }
        },
        sort: [{ column: 'name', order: 'asc' }]
      }
    };
    this.jobPositionService.getJobPositionList(requestData).subscribe({
      next: (response) => {
        if (response && response.status === 'SUCCESS') {
          const positions = response.data.job_positions || [];
          this.jobPositionsList = positions.map((p: any) => ({
            title: p.name,
            value: p.name
          }));
          this.initializeFilters();
        }
      },
      error: (err) => {
        console.error('Failed to load job positions', err);
      }
    });
  }

  getAssignedShops(shopNamesStr: string): string[] {
    if (!shopNamesStr) return [];
    return shopNamesStr.split('||');
  }

  /**
    * initilaize the device model
    */
  ngOnInit(): void {
    this.breakpointObserver.observe([Breakpoints.Handset]).subscribe((state: BreakpointState) => {
      if (state.matches) {
        this.isHandset = true;
      } else {
        this.isHandset = false;
      }
    });
    //this.loadRating();
    //this.loadData();
  }
  /** 
  * Set the datasource
  */
  setDataSource(employeeList: EmployeeCategoryModel[]) {
    this.dataSource = new MatTableDataSource(employeeList);
    this.dataSource.sort = this.sort;
  }
  @ViewChild(MatSort) sort!: MatSort;
  @ViewChild('searchFilter') searchFilter!: SearchFilterComponent;
  ngAfterViewInit(): void {
    this.loadPreviousState();
    this.isInitializing = false;
  }

  /**
   * loads the previous state if exists
   */
  loadPreviousState(): void {

    var previousState = this.stateManagerService.getState(this.constructor.name);

    if (previousState !== undefined && this.searchFilter != undefined) {

      if (previousState.state.search.filters.scope) {
        this.pagingData.pageIndex = previousState.state.search.filters.scope.offset / previousState.state.search.filters.scope.limit;
        this.pagingData.pageSize = previousState.state.search.filters.scope.limit;
      }

      if (previousState.state.search.sort != undefined && previousState.state.search.sort.length > 0) {
        this.setSortColumn(previousState.state.search.sort[0].column, previousState.state.search.sort[0].order);
      }

      this.searchColumFilter = JSON.parse(JSON.stringify(previousState.state.search.filters));
      this.searchFilter.setSearchFilter(this.searchColumFilter, true);

    } else {
      this.setSortColumn('f_name', 'asc');
      this.loadData();
    }

  }

  /**
   * Sets the sort column
   * @param column 
   * @param direction 
   */
  setSortColumn(column: string, direction: SortDirection): void {
    this.columnSortData.length = 0;
    this.columnSortData.push({ column: column, order: direction });
    if (this.sort) {
      this.sort.sort({
        id: column,
        start: direction,
        disableClear: false,
      });
    }

    // this.sort.active=column;
    // this.sort.direction=direction;


  }


  isAllSelected() {
    const numSelected = this.selection.selected.length;
    const numRows = this.employeeList.length;
    return numSelected === numRows;
  }

  toggleAllRows() {
    if (this.isAllSelected()) {
      this.selection.clear();
      return;
    }

    this.selection.select(...this.employeeList);
  }

  /**
   * Create sort order
   * @returns sort criteria
   */
  getSort(): SearchSort[] {
    return this.columnSortData;
  }

  /**
     * Builds the request data to be send to API
     * @returns Request Data
     */
  buildRequestData(): RequestData {
    let searchParam = this.getSearchParam();
    let requestData: RequestData = {
      search: {
        filters: {
          simpleSearch: searchParam.freeSearch,
          advSearch: [
            ...(searchParam.advSearch || []),
            ...this.getDefaultSearchParams(searchParam.advSearch),
          ],
          scope: {
            limit: this.pagingData.pageSize,
            offset: (this.pagingData.pageIndex * this.pagingData.pageSize),
          }
        },
        sort: this.getSort(),
      }
    };

    return requestData;
  }

  getDefaultSearchParams(searchFilter: any): ColumnFilter[] {
    var defFilter: any = [];
    if (
      searchFilter == undefined ||
      !searchFilter.some((sf: any) => sf.column == "shop_id")
    ) {
      const userStr = sessionStorage.getItem('user');
      if (userStr) {
        try {
          const user = JSON.parse(userStr);
          const userType = user.user_type;

          if (userType === 'SHOP') {
            const shopId = user.shop_id;
            defFilter.push({
              column: "shop_id",
              operator: "=",
              value: shopId
            });
          } else if (userType === 'AREA_MANAGER') {
            const userShops = user.user_shops || [];
            const shopIds = userShops.map((s: any) => String(s.id));
            defFilter.push({
              column: "shop_id",
              operator: "in",
              value: shopIds
            });
          }
        } catch (e) {
          console.error('Error parsing user session in getDefaultSearchParams:', e);
        }
      }
    }
    return defFilter;
  }

  /**
    * Set the column filter and reaload the daaa
    * @param columFilter 
    */

  onFilterApplied(columFilter: any): void {
    this.searchColumFilter = columFilter;
    this.loadData();

  }

  /**
    * On delete menu item selected
    * Confirm the action and call the api to update
    */
  onDelete(employeeInfo: EmployeeCategoryModel): void {
    const areaId = employeeInfo.id;
    const message = `Are you sure, you want to delete ` + (employeeInfo.name + "?");
    const dialogData = new ConfirmDialogModel("Confirm Deletion", message);

    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      maxWidth: "400px",
      data: dialogData
    });

    dialogRef.afterClosed().subscribe(dialogResult => {
      console.log(dialogResult);
      if (dialogResult) {
        this.employeeService.delete(employeeInfo).subscribe({
          next: (response) => {
            if (response.status == 'SUCCESS') {
              // handle success
              let snckBarData: SnackBarData = {
                type: 'success',
                title: 'Saved',
                message: 'The record for ' + employeeInfo.name + " has been deleted succesfully."
              }

              this.loadData();
            } else {
              let snackBarData: SnackBarData = {
                message: response.message,
                title: 'Failed!!!',
                type: 'error'
              }
              this.snackBarService.openSnackBar(snackBarData);
            }
          },
          error: (error) => {
            let snackBarData: SnackBarData = {
              message: 'Failed to update. Connection to the server failed',
              title: 'Failed!!!',
              type: 'error'
            }
            this.snackBarService.openSnackBar(snackBarData);
          }
        });
      }
    });
  }

  /**
   * loads the data based on the conditions
   */

  loadData(): void {
    this.isLoading = true;
    let requestData = this.buildRequestData();
    let response = this.employeeService.getEmployeeList(requestData).subscribe(response => {
      if (response.status == 'SUCCESS') {
        const mappedEmployees = (response.data.employees || []).map((emp: any) => ({
          ...emp,
          id: emp.employee_id || emp.id,
          code: emp.employee_id || emp.code,
          f_name: emp.first_name || emp.f_name,
          m_name: emp.middle_name || emp.m_name,
          l_name: emp.last_name || emp.l_name,
          status: emp.employee_status === 'Active' ? '1' : (emp.status || '2'),
          sex: emp.gender === 'male' ? 'M' : (emp.gender === 'female' ? 'F' : emp.sex),
          gender: emp.gender ? (emp.gender.charAt(0).toUpperCase() + emp.gender.slice(1).toLowerCase()) : emp.gender,
          phone: emp.phone_mobile || emp.phone,
          email: emp.email || emp.work_email,
          wage_type: emp.employee_type === 'Full-time' ? '2' : (emp.wage_type || '1')
        }));

        this.employeeList = mappedEmployees;
        this.setDataSource(mappedEmployees);
        this.pagingData.length = response.data.total_count || mappedEmployees.length;
        if (this.pagingData.length == 0) {
          let snackBarData: SnackBarData = {
            message: 'No data found. Please remove or change the filter if any.',
            title: 'No Data!!!',
            type: 'warn'
          }
          this.snackBarService.openSnackBar(snackBarData);
          this.selectedItem = undefined;
        } else {
          this.onRowSelected(this.employeeList[0])
          this.stateManagerService.setState(this.constructor.name, requestData);
        }
      } else {
        let snackBarData: SnackBarData = {
          message: response.message,
          title: 'Failed!!!',
          type: 'error'
        }
        this.snackBarService.openSnackBar(snackBarData);
      }
      this.isLoading = false;
    });

  }

  /**
  * On employeeInfo selected
  * @param employeeInfo 
  */
  onRowSelected(employeeInfo: EmployeeCategoryModel): void {
    this.selectedItem = employeeInfo;
    this.showSummaryPanel = true;
  }

  /**
    *  Set the sort param and relead the data
    * @param $event sort data
    * {"active": "email","direction": "asc"}
    *   
    */
  sortData($event: any): void {
    var sd = this.sort;
    this.columnSortData.length = 0;
    this.columnSortData.push({ column: sd.active, order: sd.direction });
    if (!this.isInitializing) {
      this.loadData();
    }
  }
  /**
* Creates the column filter conditions based on search criteria
* @returns Filter condions for columns
*/
  getSearchParam(): SearchParam {

    return this.searchColumFilter;
  }

  /**
 * On edit the item
 * Show the edit dialog
 */
  onEdit(employeeInfo: EmployeeCategoryModel): void {

    this.router.navigate(['employee/employee-edit', employeeInfo.id]);
  }


  /**
   * 
   * @param event 
   * When page size is changed update paging data
   */
  onePageEvent(event: any): void {

    this.pagingData.pageIndex = event.pageIndex;
    this.pagingData.pageSize = event.pageSize;

    this.loadData();

  }

  /**
   * On Add clicked
   * Show the dialog to enter new area
   */
  addClicked(): void {

    this.router.navigate(['employee/employee-edit', 0]);

  }
  exportClicked() {
    if (this.pagingData.length === 0) {
      let snackBarData: SnackBarData = {
        message: 'No data found to export. Please remove or change the filter if any.',
        title: 'No Data!!!',
        type: 'warn'
      };
      this.snackBarService.openSnackBar(snackBarData);
      return;
    }
    this.isLoading = true;
    let requestData = this.buildRequestData();
    this.IsDownloading = true;
    this.employeeService.downloadExcel(requestData)
      .subscribe({
        next: blob => {
          // Download logic
          this.IsDownloading = false;
          const url = window.URL.createObjectURL(blob);
          const link = document.createElement('a');
          link.href = url;
          link.download = 'employeecategory.csv'; // Adjust filename if needed
          link.click();
          window.URL.revokeObjectURL(url);
          this.isLoading = false;


        },
        error: error => {
          // Handle errors
          this.IsDownloading = false;
          let snackBarData: SnackBarData = {
            message: 'Failed to update. Connection to the server failed',
            title: 'Failed!!!',
            type: 'error'
          }
          this.snackBarService.openSnackBar(snackBarData);
          this.isLoading = false;
          // Display user-friendly error message to the user
        }
      });
  }

  openJobBreak(employee: any) {
    this.dialog.open(EmployeeJobBreakDialogComponent, {
      width: '700px',
      data: {
        employee: {
          ...employee,
          display_name: employee.display_name || employee.name || (employee.f_name + ' ' + (employee.l_name || ''))
        }
      },
      disableClose: true
    });
  }
}

